"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const generic = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-generic` : '') + (description ? ` desc-generic` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-generic"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-generic"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    d: "M35.5.25a2.25 2.25 0 0 1 2.25 2.25v19a2.25 2.25 0 0 1-2.25 2.25h-33A2.25 2.25 0 0 1 .25 21.5v-19A2.25 2.25 0 0 1 2.5.25h33Zm.75 8H1.75V21.5c0 .414.336.75.75.75h33a.75.75 0 0 0 .75-.75V8.25Zm-23.75 4a2.25 2.25 0 0 1 2.25 2.25v1a2.25 2.25 0 0 1-2.25 2.25h-5a2.25 2.25 0 0 1-2.25-2.25v-1a2.25 2.25 0 0 1 2.25-2.25h5Zm0 1.5h-5a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm23-12h-33a.75.75 0 0 0-.75.75v4.25h34.5V2.5a.75.75 0 0 0-.75-.75Z"
  }));
};
var _default = exports.default = generic;